<mat-toolbar class="subtitulo">Cadastro de RIM</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div fxLayout="row" fxLayoutAlign="end center" *ngIf="rim.id" style="margin-bottom: 10px;">
        <button mat-raised-button name="botaoRecarregarTabelas" color="accent"
                [disabled]="camposDesabilitados()" (click)="recarregarTodasTabelas()">
            <mat-icon>refresh</mat-icon> Recarregar Tabelas
        </button>
    </div>
    <form #formCadastro="ngForm"
          (keydown.enter)="$event.preventDefault(); isAtualizar && mostrarBotaoAtualizar && !rim.finalizado && !formCadastro.invalid && !camposDesabilitados() ? atualizar() : ((!isAtualizar && mostrarBotaoCadastrar && !formCadastro.invalid && !camposDesabilitados()) ? cadastrar() : null)">
        <div fxLayout="row" fxFlexFill>
            <div ngModelGroup="comboUnidade" fxFlex="100">
                <combo-unidade
                        [showDisplayId]="false"
                        [obrigatorio]="true"
                        [selecionado]="rim.unidade"
                        (valorChange)="onValorChangeUnidade($event)"
                        [desabilitado]="camposDesabilitados()">
                </combo-unidade>
            </div>

            <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="20">
                <mat-label>Data Inicio</mat-label>
                <input matInput name="dataInicio" [matDatepicker]="dataInicioPicker" placeholder="Data Inicio"
                       [(ngModel)]="rim.dataInicio" (input)="onMascaraDataInput($event)" maxlength="10" required
                       [disabled]="camposDesabilitados()">
                <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
                <mat-datepicker #dataInicioPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="20">
                <mat-label>Data Fim</mat-label>
                <input matInput name="dataFim" [matDatepicker]="dataFimPicker" placeholder="Data Fim"
                       [(ngModel)]="rim.dataFim" (input)="onMascaraDataInput($event)" maxlength="10" required
                       [disabled]="camposDesabilitados()">
                <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
                <mat-datepicker #dataFimPicker></mat-datepicker>
            </mat-form-field>
        </div>


        <div fxLayout="row" fxFlexFill>
            <div ngModelGroup="comboContrato" fxFlex="100">
                <combo-contrato [showDisplayId]="false"
                                [obrigatorio]="true"
                                [selecionado]="rim.contrato"
                                (valorChange)="onValorChangeContrato($event)"
                                [desabilitado]="camposDesabilitados()">
                </combo-contrato>
            </div>

            <div style="margin-left: 26px;">
                <mat-checkbox color="primary"
                              title="Modelo RIM Padrão"
                              name="modeloPadraoRIm"
                              [(ngModel)]="rim.modeloPadrao"
                              style="margin-top: 20px;" [disabled]="camposDesabilitados()">
                    Modelo RIM Padrão
                </mat-checkbox>
            </div>
        </div>

        <div fxLayout="row" fxFlexFill>
            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoMetasObjetivo">
                <div *ngFor="let capitulo of rim.capitulos; let index = index">
                    <capitulo-rim [capitulo]="capitulo"
                                  [index]="index"
                                  [listaCapitulos]="rim.capitulos"
                                  [camposDesabilitados]="camposDesabilitados()"
                                  [consultasBanco]="consultasBanco">
                    </capitulo-rim>
                </div>
                <div fxLayoutAlign="start center" fxLayoutGap="16px"
                     style="padding-top: 10px; padding-left: 20px;">
                    <div>
                        <button matTooltip="Novo Capítulo" mat-mini-fab color="primary" (click)="addCapituloRim()"
                                style="width: 100px;border-radius: 5px;" *ngIf="!camposDesabilitados()">
                            <mat-icon>add</mat-icon>
                            Capítulo
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
             fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                    color="primary" [disabled]="formCadastro.invalid ||  camposDesabilitados()" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar &&  !rim.finalizado" mat-raised-button name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary" [disabled]="formCadastro.invalid || camposDesabilitados()" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

            <button mat-raised-button name="botaoRelatorio" fxFlex="20%" *ngIf="rim.id" color="primary"
                    [disabled]="formCadastro.invalid || !rim.id" (click)="abrirOpcoesRelatorio()"> Gerar Relatório
            </button>
        </div>

    </form>
</div>
